import firebase from 'firebase';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"
import moment from "moment-timezone";
//const cn = 'OA_UAT_C1591205467009E1591206650065'

var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');

var groupRef = con.eventDB.collection(cn).doc("GroupList").collection("Groups");
const NotificationRef = con.eventDB.collection(cn).doc('NotificationList').collection('Notifications');
// const categoryRef = con.eventDB.collection(cn).doc("ExhibitorCategories").collection("Category");
const storageRef = con.storageRef;
var SendAttendeeAndGroupPushAPI = con.SendAttendeeAndGroupPushAPI;

export default {
    fetchAttendeeDropdown({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            NotificationRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push({ 
                        Attendees: doc.data().Attendees.Name, 
                        CreatedDate: doc.data().CreatedDate, 
                        IsScheduled: doc.data().IsScheduled, 
                        NotificationMessage: doc.data().NotificationMessage, 
                        DeepLink: doc.data().DeepLink ? doc.data().DeepLink : null,
                        NotificationName: doc.data().NotificationName, 
                        scheduleDateTime: doc.data().scheduleDateTime, 
                        status: doc.data().status
                    })
                })
                commit('SET_NOTIFICATIONS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchNotification(context, id) {
        //console.log(id)
        debugger;
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {

                        BoothNo: '',
                        Category: '',
                        HtmlCode: '',
                        CreatedDate: '',
                        Email: '',
                        ExhibitorId: '',
                        HotspotImageURL: '',
                        LastModifiedDate: '',
                        Logo: '',
                        MappedContacts: [],
                        Name: '',
                        Phone: '',
                        Profile: '',
                        IsPublished: true,

                        Resources: [],
                        ShowcaseImages: [],

                        ShowcaseVideoURL: '',
                        SocialLinks: [
                            { Facebook: '' },
                            { Twitter: '' },
                            { GooglePlus: '' },
                            { LinkedIn: '' }
                        ],
                        Website: ''

                    }
                })
            } else {
                let docObj = new Object
                NotificationRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    debugger;
                    console.log(docObj);

                    docObj.scheduleDateTime = moment(docObj.scheduleDateTime.seconds * 1000)
                    var IsSentToAttendee = false;
                    if (docObj.Attendees) {
                        IsSentToAttendee = true;
                    }
                    docObj.IsSentToAttendee = IsSentToAttendee;

                    var IsSentTogroup = false;
                    if (docObj.Groups) {
                        IsSentTogroup = true;
                    }
                    docObj.IsSentTogroup = IsSentTogroup;


                    var IsAllAttendees = false;
                    if (!docObj.Groups && !docObj.Attendees) {
                        IsAllAttendees = true;
                    }
                    docObj.IsAllAttendees = IsAllAttendees;



                    //  docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    // if (docObj.HtmlCode == undefined) {
                    //     docObj.HtmlCode = "";
                    // }

                    // if (doc.data().SocialLinks) {
                    //     for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                    //         let socialkeys = Object.keys(doc.data().SocialLinks[i])
                    //         let socialvaues = Object.values(doc.data().SocialLinks[i])
                    //         docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                    //     }
                    // }
                    // docObj.Resources = (doc.data().Resources ? doc.data().Resources : [])
                    //console.log(docObj)                      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateNotification(context, field) {
        debugger;
        return new Promise((resolve, reject) => {

            if (field.data.IsSentToAttendee) {
                let docObj = {
                    Attendees: field.data.Attendees.map((rows) => {
                        return {
                            AttendeeID: rows.AttendeeID != undefined ? rows.AttendeeID.toString() : rows.AttendeeId.toString(),
                            Email: rows.Email.toString(),
                            Name: rows.Name.toString()

                        }
                    }),
                    LastModifiedDate: new Date(),
                    IsScheduled: field.data.IsScheduled,

                    NotificationMessage: field.data.NotificationMessage,
                    NotificationTitle: field.data.NotificationTitle,
                    DeepLink: field.data.DeepLink,
                    //  scheduleDateTime: this.GetTimeByZone(field.data.scheduleDateTime, field.TimeZone)
                    scheduleDateTime: field.data.scheduleDateTime != "Invalid Date" ? field.data.scheduleDateTime : ""
                }
                debugger;
                console.log(field.data)
                NotificationRef.doc(`${field.id}`).update(docObj)
                    .then(function(doc) {
                        resolve({ status: 200, message: 'Data Updated.' })

                    }).catch(function(error) {
                        //console.log('Error getting update attendee:', error)
                        reject(error)
                    })
            } else if (field.data.IsSentTogroup) {
                console.log(field);
                debugger;
                let docObjgrp = {
                    Groups: field.data.Groups.map((rows) => {
                        return {
                            GroupId: rows.GroupId.toString(),
                            GroupName: rows.GroupName.toString()
                        }
                    }), //field.data.Groups,
                    LastModifiedDate: new Date(),
                    IsScheduled: field.data.IsScheduled,

                    NotificationMessage: field.data.NotificationMessage,
                    NotificationTitle: field.data.NotificationTitle,
                    DeepLink: field.data.DeepLink,
                    //  scheduleDateTime: this.GetTimeByZone(field.data.scheduleDateTime, field.TimeZone)
                    scheduleDateTime: field.data.scheduleDateTime != "Invalid Date" ? field.data.scheduleDateTime : ""
                }
                debugger;
                NotificationRef.doc(`${field.id}`).update(docObjgrp)
                    .then(function(doc) {
                        resolve({ status: 200, message: 'Data Updated.' })

                    }).catch(function(error) {
                        //console.log('Error getting update attendee:', error)
                        reject(error)
                    })

            } else if (field.data.IsAllAttendees) {
                console.log(field);

                let docObjgrp = {

                    LastModifiedDate: new Date(),
                    IsScheduled: field.data.IsScheduled,

                    NotificationMessage: field.data.NotificationMessage,
                    NotificationTitle: field.data.NotificationTitle,
                    DeepLink: field.data.DeepLink,
                    //  scheduleDateTime: this.GetTimeByZone(field.data.scheduleDateTime, field.TimeZone)
                    scheduleDateTime: field.data.scheduleDateTime != "Invalid Date" ? field.data.scheduleDateTime : ""
                }
                NotificationRef.doc(`${field.id}`).update(docObjgrp)
                    .then(function(doc) {
                        resolve({ status: 200, message: 'Data Updated.' })

                    }).catch(function(error) {
                        //console.log('Error getting update attendee:', error)
                        reject(error)
                    })

            }
        })
    },
    sendNotificationToAllAttendee(context, data){
        return new Promise((resolve, reject) => {
          var docObj = new Object();
          docObj.TopicConvention = cn;
          docObj.Type = 1;
          docObj.CreatedDate = new Date();
          docObj.LastModifiedDate = new Date();
          docObj.IsScheduled = false;
          docObj.NotificationTitle = data.NotificationName;
          docObj.NotificationMessage = data.NotificationMessage;
          docObj.DeepLink = data.DeepLink;
          docObj.scheduleDateTime = null;
          docObj.status = "sent";

          NotificationRef.add(docObj).then(function (e) {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            let headers = {
              Authorization: `Bearer ${accessToken}`,
              "content-type": "application/json",
            };
            let requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: Session_Client_Id,
                eventId: Session_Event_Id,
              },
              data: {
                NotificationId: e.id,
              },
            };

            axios.post(SendAttendeeAndGroupPushAPI, requestData, { headers: headers }).then((response) => {
                resolve({
                  status: 200,
                  message: "Notification Sent successfully",
                });
              })
              .catch((error) => {
                reject(error)
              });

          });
        });
    },
    GetTimeByZone: function(strDateTime, timeZone) {
        debugger;
        strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
        var strtDate = moment.tz(strDateTime, timeZone);
        strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
        return strtDate._d;
    },
    fetchgroups({ commit }) {
        debugger;
        Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
        //  groupRef = con.eventDB.collection(cn).doc("GroupList").collection("Groups"); ///OA_UAT_C1591904892446E1591907102804/GroupList/Groups/10001/MappedAttendees/191002
        return new Promise((resolve, reject) => {
            let markers = []
            groupRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                        //  console.log(doc.data().MappedAttendees);
                        // if (doc.data().ShowInCMSAttendeeList == undefined) {

                        //     markers.push(doc.data())
                        // } else if (doc.data().ShowInCMSAttendeeList == 1) {
                        //     markers.push(doc.data())
                        // }
                        if (doc.data().IsPublished) {
                            markers.push(doc.data());
                        }
                    })
                    // console.log(markers);
                commit('SET_GROUPS', markers)
                resolve(markers)
            }).catch(function(error) {
                console.log('Error getting groups:', error)
                reject(error)
            })

        })
    },
}